import lodashGet from 'lodash/get';
import { api } from '@/api/api';
import { util } from '@/api/util';
export class ContactSearchTransform {
    constructor() {
        this.systemApi = api.getSystemApi();
    }
    transServerContact2Search(rawData) {
        const { qiyeNickName = '' } = rawData;
        return {
            id: rawData.qiyeAccountId,
            contactName: qiyeNickName,
            contactPYName: util.toPinyin(qiyeNickName),
            contactPYLabelName: qiyeNickName
                .split('')
                .map(item => util.toPinyin(item).slice(0, 1))
                .join(''),
            accountName: (rawData.displayEmail || rawData.email).toLocaleLowerCase(),
            avatar: lodashGet(rawData, 'iconVO.mediumUrl', ''),
            avatarPendant: lodashGet(rawData, 'iconVO.pendantUrl', ''),
            visibleCode: 0,
            type: 'enterprise',
            position: [],
            enterpriseId: rawData.orgId,
        };
    }
    transServerPersonalContact2Search(rawData) {
        const qiyeAccountName = rawData.qiyeAccountName || '';
        return {
            id: rawData.qiyeAccountId,
            contactName: qiyeAccountName,
            contactPYName: util.toPinyin(qiyeAccountName),
            contactPYLabelName: qiyeAccountName
                .split('')
                .map(item => util.toPinyin(item).slice(0, 1))
                .join(''),
            accountName: lodashGet(rawData, 'email[0]', ''),
            avatar: lodashGet(rawData, 'iconVO.mediumUrl', ''),
            avatarPendant: '',
            visibleCode: 0,
            type: 'personal',
            position: [],
            enterpriseId: -1,
        };
    }
    transServerTeam2Org() { }
    transNewServerSearchResult2ContactSearch(item, localAvatar = '', localAvatarPendant = '') {
        return {
            id: item.id,
            contactName: item.name,
            contactPYName: '',
            contactPYLabelName: '',
            accountName: item.email.toLowerCase(),
            position: item.unitNames,
            type: 'enterprise',
            avatar: localAvatar,
            avatarPendant: localAvatarPendant,
            visibleCode: 0,
            accountType: 2,
        };
    }
    transSearchServerContact2EntityContact(item, enterpriseId) {
        const email = (item.email || '').toLowerCase();
        const displayEmail = (item.displayEmail || item.email || '').toLowerCase();
        const name = item.name || '';
        const now = Date.now();
        return {
            id: item.id,
            accountOriginId: item.id,
            accountName: email,
            displayEmail,
            contactName: name,
            contactPYName: '',
            contactPYLabelName: '',
            contactLabel: '',
            enterpriseId,
            type: 'enterprise',
            _lastUpdateTime: now,
            updateTime: new Date(now),
            avatar: '',
            avatarPendant: '',
            position: item.unitNames || [],
            visibleCode: 0,
            accountVisible: 0,
            accountStatus: 0,
            accountType: 2,
            job: '',
        };
    }
    transSearchServerContact2EntityContactItem(item, enterpriseId) {
        const now = Date.now();
        const _email = (item.email || '').toLowerCase();
        const _displayEmail = (item.displayEmail || '').toLowerCase();
        const allEmails = [...new Set([_displayEmail, _email].filter(e => e && e.trim().length > 0))];
        return allEmails.map((emailVal, index) => ({
            id: util.getUnique(item.id, 'EMAIL', emailVal),
            contactItemVal: emailVal,
            contactItemRefer: '',
            contactItemType: 'EMAIL',
            emailType: index === 0 ? -1 : 1,
            isDefault: (index === 0 ? 1 : 0),
            contactId: item.id,
            type: 'enterprise',
            enterpriseId,
            _lastUpdateTime: now,
            updateTime: now,
        }));
    }
}
